import React, { useRef, useState } from "react";
import Logo from "../../images/logo.png";
import LogoDark from "../../images/logo.png";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../components/Component";
import { Form, Spinner, Alert } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { adminLoginAPI } from "../../api/login/indes";
import { decrypt, encrypt } from "../../utils/Utils";
import { toast } from "react-toastify";
import Captcha from "../../MyComp/UI/Captcha/Captcha";
import axios from "axios";
import lo from "../../images/logo.png";
import { getMessagingInstance } from "../../firebase";
import { getToken } from "firebase/messaging";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const encryptedData = localStorage.getItem("userDetail");
  const userData = encryptedData ? decrypt(encryptedData) : null;
  const token = localStorage.getItem("accessToken");
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [errorVal, setError] = useState("");
  const [captchaValid, setCaptchaValid] = useState(false);
  const [captchaTouched, setCaptchaTouched] = useState(false);
  const [captchaError, setCaptchaError] = useState(null); // To track if CAPTCHA has been interacted with
  const captchaRef = useRef(null);

  const onFormSubmit = async (formData) => {
    setCaptchaTouched(true);
    if (!captchaValid) {
      setCaptchaError("Captcha is required");
      captchaRef.current.resetCaptcha();
      return;
    }

    setLoading(true);

    try {
      let ipAddress = "Unknown";
      try {
        const response = await axios.get("https://ipinfo.io/json?token=7ef19370e91880");
        ipAddress = response?.data?.ip || ipAddress;
      } catch (err) {
        console.warn("Unable to fetch IP info, continuing without it", err);
        ipAddress = window.location.hostname || ipAddress;
      }

      const os = navigator.platform || "Unknown OS";
      const userAgent = navigator.userAgent || "";
      let browserName = "Unknown Browser";
      if (userAgent.includes("Firefox")) {
        browserName = "Mozilla Firefox";
      } else if (userAgent.includes("Chrome") && !userAgent.includes("Chromium")) {
        browserName = "Google Chrome";
      } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
        browserName = "Safari";
      } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
        browserName = "Internet Explorer";
      } else if (userAgent.includes("Edge") || userAgent.includes("Edg")) {
        browserName = "Microsoft Edge";
      }

      let notificationToken = null;
      try {
        if (typeof Notification !== "undefined" && Notification.requestPermission) {
          const permission = await Notification.requestPermission();
          if (permission === "granted") {
            const messaging = await getMessagingInstance();
            if (messaging) {
              notificationToken = await getToken(messaging, {
                vapidKey: "BMtpfp_S0LgEvXbK9N891iuuh_AH2ucWVNVnRwMDKQUVXMTRU581XiHLFPnfG4gNro5MUj9SrHi06RzeKGz9E4o",
              });
            }
          }
        }
      } catch (err) {
        console.warn("Notification token unavailable, continuing login", err);
      }

      const myKey = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
      const body = {
        email: formData.name,
        password: formData.passcode,
        device_id: getDeviceId(),
        notificationToken,
        os,
        browser: browserName,
        ip: ipAddress,
        magic: encrypt(myKey),
      };

      const b = { en: encrypt(body) };
      const res = await adminLoginAPI(b);
      const status = decrypt(res?.data?.status || "");

      if (status === "success") {
        const decryptedData = decrypt(res?.data?.data || "");
        if (decryptedData?.magic === myKey) {
          localStorage.setItem("accessToken", decryptedData.token);
          localStorage.setItem("userDetail", res.data.data);
          localStorage.setItem("userId", decryptedData.id);
          localStorage.setItem("userName", decryptedData.name);
          localStorage.setItem("role", decryptedData.role);

          toast.success("You have logged in successfully!");
          if (decryptedData?.role === "admin") {
            navigate("/dashboard");
          } else if (decryptedData?.role === "pharmacy") {
            navigate("/pharmacy-dashboard", {
              state: { pharmacyId: decryptedData?.id, name: decryptedData?.name },
            });
          } else if (decryptedData?.role === "lab") {
            navigate("/laboratory-dashboard", {
              state: { labId: decryptedData?.id, name: decryptedData?.name },
            });
          } else if (decryptedData?.role === "telecaller") {
            navigate("/telecaller-dashboard", {
              state: { pharmacyId: decryptedData?.id, name: decryptedData?.name },
            });
          } else if (decryptedData?.role === "hospital") {
            navigate("/hospital-dashboard", {
              state: { hospitalId: decryptedData?.id, name: decryptedData?.name },
            });
          }
        } else {
          toast.error(res?.data?.message || "Login failed");
          captchaRef.current.resetCaptcha();
        }
      } else {
        toast.error(res?.data?.message || "Login failed");
        captchaRef.current.resetCaptcha();
      }
    } catch (error) {
      console.log("Login error:", error);
      captchaRef.current?.resetCaptcha();
      toast.error("Unable to login right now. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getDeviceId = () => {
    let deviceId = localStorage.getItem("deviceId");

    if (!deviceId) {
      deviceId = "dev-" + Math.random().toString(36).substr(2, 9);
      localStorage.setItem("deviceId", deviceId);
    }

    return deviceId;
  };
  const deviceId = getDeviceId();
  console.log(deviceId, "deviceid");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <>
      <Head title="Login" />
      <Block className="nk-block-middle nk-auth-body  wide-xs">
        <div className="brand-logo pb-4 text-center">
          <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
            <img className="logo-light logo-img logo-img-lg" src={lo} alt="logo" />
            <img className="logo-dark logo-img logo-img-lg" src={lo} alt="logo-dark" />
          </Link>
        </div>

        <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
          <BlockHead>
            <BlockContent>
              <BlockTitle tag="h4">Sign-In</BlockTitle>
              <BlockDes>
                <p>Access Admin Panel using your email and password.</p>
              </BlockDes>
            </BlockContent>
          </BlockHead>
          {errorVal && (
            <div className="mb-3">
              <Alert color="danger" className="alert-icon">
                <Icon name="alert-circle" /> Unable to login with credentials{" "}
              </Alert>
            </div>
          )}
          <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label" htmlFor="default-01">
                  Email or Username
                </label>
              </div>
              <div className="form-control-wrap">
                <input
                  type="text"
                  id="default-01"
                  {...register("name", { required: "This field is required" })}
                  defaultValue="anand@gmail.com"
                  placeholder="Enter your email address or username"
                  className="form-control-lg form-control"
                />
                {errors.name && <span className="invalid">{errors.name.message}</span>}
              </div>
            </div>
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label" htmlFor="password">
                  Password
                </label>
                <Link className="link link-primary link-sm" to={`${process.env.PUBLIC_URL}/auth-reset`}>
                  Forgot Password?
                </Link>
              </div>
              <div className="form-control-wrap">
                <a
                  href="#password"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setPassState(!passState);
                  }}
                  className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                >
                  <Icon name="eye" className="passcode-icon icon-show"></Icon>

                  <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                </a>
                <input
                  type={passState ? "text" : "password"}
                  id="password"
                  {...register("passcode", { required: "This field is required" })}
                  defaultValue="123456"
                  placeholder="Enter your password"
                  className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                />
                {errors.passcode && <span className="invalid">{errors.passcode.message}</span>}
              </div>
            </div>
            <Captcha ref={captchaRef} setCaptchaValid={setCaptchaValid} setCaptchaError={setCaptchaError} />
            {captchaTouched && (
              <span className="invalid" style={{ color: "#e85347", fontSize: "11px", fontStyle: "italic" }}>
                {captchaError}
              </span>
            )}
            <div className="form-group">
              <Button size="lg" className="btn-block" type="submit" color="primary">
                {loading ? <Spinner size="sm" color="light" /> : "Sign in"}
              </Button>
            </div>
          </Form>
        </PreviewCard>
      </Block>
      <AuthFooter />
    </>
  );
};
export default Login;
